
<app-smart-table [settings]="settings" [source]="source" tableDiv="assign-table-basic" [withWrapper]="true"></app-smart-table>
